module.exports = __webpack_public_path__ + "img/instagram.cab8889c.svg";